import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Fade from "@mui/material/Fade";
import { keyframes } from "@mui/system";

// Define the gradient animation
const gradientAnimation = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

const Answering = ({ loading }) => {
  return (
    <Fade timeout={1000} in={loading}>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          display: "flex",
          alignItems: "center",
          alignContent: "top",
          pl:0.6
        }}
      >
        <CircularProgress size={22} color="primary" sx={{ p: 0, m: 0 }} />
        <Box
          sx={(theme) => ({
            pt: 1,
            pb: 1,
            pl: 2,
            pr: 2,
            m: 0,
            borderRadius: 4,
            display: "flex",
            backdropFilter: "blur(24px)",
            boxShadow: "rgba(0, 0, 0, 0.05) 0px 4px 12px",
            bgcolor:
              theme.palette.mode === "light"
                ? "rgba(248, 255, 252, 0.4)"
                : "rgba(0, 0, 0, 0.8)",
          })}
        >
          <Typography
            variant="body1"
            sx={{
              background: (theme) => 
                theme.palette.mode === "light"
                  ? "linear-gradient(90deg, #b636b9, #7760b9, #207a94, #009400)"
                  : "linear-gradient(90deg, #b636b9, #7760b9, #207a94, #009400)",
              backgroundSize: "350% auto",
              color: "transparent",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              animation: `${gradientAnimation} 3s ease infinite`,
              fontWeight: 500,
              opacity: 0.8
            }}
          >
            Answering your question...
          </Typography>
        </Box>
      </Stack>
    </Fade>
  );
};

export default Answering;